import { render, staticRenderFns } from "./brand-modal-factory.vue?vue&type=template&id=2c258fcd&scoped=true"
import script from "./brand-modal-factory.vue?vue&type=script&lang=js"
export * from "./brand-modal-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c258fcd",
  null
  
)

export default component.exports